import React from "react";

import { CommandBlock } from "../common/Commands2";

export default function Page() {
  return (
    <>
      <h1>Sale Orders Sync</h1>
      <p className="print-hide">
        Synchronise cached sale order list with MYOB. If you have changed
        something directly in MYOB and it is not showing up in one of the
        systems, you can run this manually.
      </p>
      <CommandBlock
        endpoint="/command/sync-orders"
        enabled
        schedule
      />
    </>
  );
}
